import React from 'react'
import Layout from './Layout'
import styles from './_layout.css'

export default function WideLayout (props) {
  return (
    <Layout
      className={styles.wide}
      {...props}
    />
  )
}
